import { ApiService } from "@/api";

export default {
  GET_LIST_USERS({ commit }, payload) {
    return ApiService.user
      .getList({
        search: encodeURI(payload.query) || "",
        page: payload.page,
        count: payload.count,
      })
      .then((data) => commit("SET_LIST_USERS", data));
  },
};
